var React = require('react');

function Invalide (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"12","cy":"12","r":"10","fill":"#BE030A","key":0}),React.createElement("path",{"d":"M16 8L8 16","stroke":"white","strokeWidth":"2","key":1}),React.createElement("path",{"d":"M8 8L16 16","stroke":"white","strokeWidth":"2","key":2})]);
}

Invalide.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Invalide;

Invalide.default = Invalide;
